import { render, staticRenderFns } from "./PartsRequirementList.vue?vue&type=template&id=a8f2159e&"
import script from "./PartsRequirementList.vue?vue&type=script&lang=js&"
export * from "./PartsRequirementList.vue?vue&type=script&lang=js&"
import style0 from "./PartsRequirementList.vue?vue&type=style&index=0&id=a8f2159e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports